import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { GdprService } from '@recruitee/gdpr/data';
import {
  ActivitySubscriptions,
  ActivitySubscriptionType,
  ActivitySubscriptionUpdateData,
} from '@recruitee/http/types';
import { I18nService, TranslatePipe } from '@recruitee/i18n';

import { ActivitySubscriptionsTableRowComponent } from '../activity-subscriptions-table/activity-subscriptions-table-row/activity-subscriptions-table-row.component';
import { ActivitySubscriptionsTableComponent } from '../activity-subscriptions-table/activity-subscriptions-table.component';

@Component({
  selector: 'rt-activity-subscriptions-followed-by-me-offer',
  templateUrl: './activity-subscriptions-followed-by-me-offer.component.html',
  styleUrls: ['../activity-subscriptions.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ActivitySubscriptionsTableComponent,
    NgIf,
    ActivitySubscriptionsTableRowComponent,
    TranslatePipe,
  ],
})
export class ActivitySubscriptionsFollowedByMeOfferComponent {
  @Input()
  public set types(types: ActivitySubscriptionType[]) {
    this.title = types.includes(ActivitySubscriptionType.Slack)
      ? this.i18n.translate('app.subscriptions.followed_by_me_offer_slack')
      : this.i18n.translate('app.subscriptions.followed_by_me_offer');
    this._types = types;
  }

  public get types(): ActivitySubscriptionType[] {
    return this._types;
  }

  @Input() public abilities = {
    viewOffers: false,
    viewCandidates: false,
    manageCandidates: false,
    viewRequisitions: false,
  };
  @Input() public activitySubscriptions: ActivitySubscriptions;
  @Input() public hasOverdueCandidates: boolean = true;
  @Input() public hasRequisitions: boolean = false;
  @Output() public changeEvents: EventEmitter<ActivitySubscriptionUpdateData> = new EventEmitter();

  public title: string;

  private _types: ActivitySubscriptionType[];

  constructor(public gdprSvc: GdprService, private i18n: I18nService) {}
}
